import './BackOffice.scss'
import React from 'react'

import Button from '../Button/Button'

function BackOffice({ part = 'all' }) {
    const showIntro = part !== 'list'
    const showList = part !== 'intro'
    const showSchema = part !== 'list'

    const openCalendly = () => {
        if (window.Calendly) {
            window.Calendly.initPopupWidget({
                url: 'https://calendly.com/contact-benjamingibert',
            })
        }
    }

    return (
        <section
            id={showIntro ? 'back-office' : undefined}
            className="backoffice"
            aria-labelledby={showIntro ? 'backoffice-title' : undefined}
            aria-label={showIntro ? undefined : 'Du site vitrine à l’outil de gestion'}
        >
            <div className="backoffice__container">
                <div className="backoffice__text">
                    <p className="backoffice__eyebrow">Au-delà de la vitrine</p>

                    {showIntro && (
                        <>
                    <h2 id="backoffice-title" className="backoffice__title">
                        Du site vitrine à l’outil de gestion
                    </h2>

                    <p className="backoffice__paragraph">
                        Un site qui présente, c’est bien. Un site qui alimente
                        vos outils de gestion, c’est mieux. Je relie votre
                        vitrine à un back-office ou à un ERP sur mesure pour
                        que vos contenus, vos commandes et vos clients soient
                        gérés au même endroit.
                    </p>
                        </>
                    )}

                    {showList && (
                        <>
                    <ul className="backoffice__list">
                        <li>
                            <strong>Vous gérez vous-même</strong> vos contenus,
                            sans repasser par un développeur
                        </li>
                        <li>
                            <strong>Une seule saisie</strong> : le site, la
                            boutique et la gestion partagent les mêmes données
                        </li>
                        <li>
                            <strong>Un outil à votre mesure</strong>, pensé
                            pour vos usages et vos équipes
                        </li>
                    </ul>

                    <Button
                        variant="accentButton"
                        onClick={openCalendly}
                        ariaLabel="Parler de votre ERP avec Benjamin Gibert via Calendly"
                    >
                        Parlons de votre outil
                    </Button>
                        </>
                    )}
                </div>

                {showSchema && (
                <figure
                    className="backoffice__schema"
                    role="img"
                    aria-label="Schéma : le site vitrine et l’outil de gestion échangent les mêmes données"
                >
                    <div className="backoffice__node">
                        <span className="backoffice__node-title">Site vitrine</span>
                        <span className="backoffice__node-caption">Ce que voit le visiteur</span>
                    </div>

                    <span className="backoffice__arrow" aria-hidden="true" />

                    <div className="backoffice__node">
                        <span className="backoffice__node-title">Outil de gestion</span>
                        <span className="backoffice__node-caption">Ce que vous pilotez</span>
                    </div>
                </figure>
                )}
            </div>
        </section>
    )
}

export default BackOffice
